var _rect, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _line1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStraight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1093,
    height: 67,
    viewBox: "0 0 1093 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1083,
    height: 67,
    transform: "matrix(-1 0 0 1 1087 0)",
    fill: "#222020"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 103,
    y1: 31.5,
    x2: 156,
    y2: 31.5,
    stroke: "white",
    strokeWidth: 5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 206,
    y1: 31.5,
    x2: 259,
    y2: 31.5,
    stroke: "white",
    strokeWidth: 5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    y1: 31.5,
    x2: 53,
    y2: 31.5,
    stroke: "white",
    strokeWidth: 5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 319,
    y1: 31.5,
    x2: 372,
    y2: 31.5,
    stroke: "white",
    strokeWidth: 5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 422,
    y1: 31.5,
    x2: 475,
    y2: 31.5,
    stroke: "white",
    strokeWidth: 5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 525,
    y1: 31.5,
    x2: 578,
    y2: 31.5,
    stroke: "white",
    strokeWidth: 5
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 628,
    y1: 31.5,
    x2: 681,
    y2: 31.5,
    stroke: "white",
    strokeWidth: 5
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 731,
    y1: 31.5,
    x2: 784,
    y2: 31.5,
    stroke: "white",
    strokeWidth: 5
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 834,
    y1: 31.5,
    x2: 887,
    y2: 31.5,
    stroke: "white",
    strokeWidth: 5
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    x1: 937,
    y1: 31.5,
    x2: 990,
    y2: 31.5,
    stroke: "white",
    strokeWidth: 5
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    x1: 1040,
    y1: 31.5,
    x2: 1093,
    y2: 31.5,
    stroke: "white",
    strokeWidth: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStraight);
export default __webpack_public_path__ + "static/media/straight.64cfecff63966582f495df075943e19d.svg";
export { ForwardRef as ReactComponent };